import React from 'react';
import { pillarResearchStatus } from '../../data/pillars';
type ResearchStatusNoteProps = {
  tone?: 'light' | 'dark';
  className?: string;
};
export function ResearchStatusNote({
  tone = 'light',
  className = ''
}: ResearchStatusNoteProps) {
  const dark = tone === 'dark';
  return <aside aria-label="Research status" className={`border-l-4 border-teal pl-6 ${className}`} data-id="element-1650" data-mp="2zwaceosgjqxq">
      <p className={`text-sm font-semibold mb-1 ${dark ? 'text-teal' : 'text-teal'}`} data-id="element-1651" data-mp="34w53otg5aijb">Research status</p>
      <p className={`leading-relaxed ${dark ? 'text-white/80' : 'text-ink-dark'}`} data-id="element-1652" data-mp="39ty8bi1sv4hh">{pillarResearchStatus}</p>
    </aside>;
}